import Action, {GET, POST_FORM,POST} from "../common/Action";

export const eventsAction = new Action('GET_EVENTS', GET, 'events/all');
export const getStoreAction = new Action('GET_STORE', GET, 'store/get');
export const setActiveEventAction = new Action('SET_ACTIVE_EVENT');
export const getDashboardInfoAction = new Action('GET_DASHBOARD_INFO', GET, ({eventId}) => `store/dashboard/${eventId}`);
export const getSubscriptionAction = new Action('GET_SUBSCRIPTION', GET, 'subscription');

export const getEvents = () => eventsAction.callApi();
export const getStore = () => getStoreAction.callApi();
export const setActiveEvent = (eventId) => setActiveEventAction.setResult({data: eventId});
export const getDashboardInfo = (eventId) => getDashboardInfoAction.callApi(null, ({eventId}));
export const getSubscription = () => getSubscriptionAction.callApi();